import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fromHour", "toHour"]

  connect() {
    if (this.hasFromHourTarget) {
      this.initTimepicker(this.fromHourTarget, this.fromHourOptions())
    }

    if (this.hasToHourTarget) {
      this.initTimepicker(this.toHourTarget, this.toHourOptions())
    }
  }

  initTimepicker(target, options) {
    $(target).timepicker(options)
  }

  fromHourOptions() {
    return { timeFormat: "H:i", minTime: "00:00", maxTime: "23:30", scrollDefault: "08:30", orientation: "rb" }
  }

  toHourOptions() {
    return { timeFormat: "H:i", minTime: "00:00", maxTime: "23:30", scrollDefault: "14:30", orientation: "rb" }
  }
}
